import { SvgIcon, type SvgIconProps } from "@mui/material";
import { type FC, type PropsWithChildren } from "react";

const SimPerUser: FC<PropsWithChildren<SvgIconProps>> = (props) => (
    <SvgIcon {...props} viewBox="0 0 16 16">
        <path
            fillRule="evenodd"
            d="M12.875,4.8 L11.25,4.8 L11.25,1.6 L12.875,1.6 L12.875,4.8 Z M10.4375,4.8 L8.8125,4.8 L8.8125,1.6 L10.4375,1.6 L10.4375,4.8 Z M8,4.8 L6.375,4.8 L6.375,1.6 L8,1.6 L8,4.8 Z M12.875,0 C13.7724627,0 14.5,0.7163444 14.5,1.6 L14.5,1.6 L14.5,14.4 C14.5,15.2836556 13.7724627,16 12.875,16 L12.875,16 L3.125,16 C2.22753728,16 1.5,15.2836556 1.5,14.4 L1.5,14.4 L1.5,4.8 L6.375,0 Z M7.99833333,11.1666667 C6.89166667,11.1666667 4.665,11.7266667 4.665,12.8333333 L4.665,13.6666667 L11.3316667,13.6666667 L11.3316667,12.8333333 C11.3316667,11.7266667 9.105,11.1666667 7.99833333,11.1666667 Z M7.995,6.8 C7.02850169,6.8 6.245,7.58350169 6.245,8.55 C6.245,9.51649831 7.02850169,10.3 7.995,10.3 C8.96149831,10.3 9.745,9.51649831 9.745,8.55 C9.745,7.58350169 8.96149831,6.8 7.995,6.8 Z"
        />
    </SvgIcon>
);

export default SimPerUser;
